module.exports = __webpack_public_path__ + "img/izibiz_png.4ba1e523.png";